<template>
  <div class="login">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      label-position="left"
      label-width="0px"
      class="login-form">
      <h3 class="title">用户登录</h3>
      <el-form-item prop="username">
        <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="账号">
          <svg-icon
            slot="prefix"
            icon-class="user"
            class="el-input__icon"
            style="height: 39px;width: 18px;margin-left: 2px;"/>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="loginForm.password"
          type="password"
          auto-complete="off"
          placeholder="密码"
          @keyup.enter.native="handleLogin">
          <svg-icon
            slot="prefix"
            icon-class="password"
            class="el-input__icon"
            style="width: 18px;height: 39px;margin-left: 2px;"/>
        </el-input>
      </el-form-item>
      <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="border-radius:20px;width:100%;"
          @click.native.prevent="handleLogin">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
      <!-- <p class="login-tip">系统默认用户名：admin，密码：123456</p> -->
    </el-form>
    <drag-dialog :show="dialogShow" :title="'修改密码'" :width="'50%'" @close="dialogShow = false" height="500px">
        <div class="error-box">
            <i class="el-icon-warning"></i>
            为了您的账号安全，初次登录时请先修改密码，且新密码不能为初始密码(123456)
        </div>
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="原密码" prop="oldPwd">
            <el-input v-model="form.oldPwd" :type="'password'" :disabled="true">
              <!-- isPwd -->
            </el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input v-model="form.password" :type="'password'"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="rePassword">
            <el-input v-model="form.rePassword" :type="'password'"></el-input>
          </el-form-item>
          <el-form-item>
            <!-- <el-checkbox v-model="isShow">显示原密码</el-checkbox> -->
            <el-button type="primary" @click="onSubmit('form')">确定</el-button>
            <el-button @click="cancel">取消</el-button>
          </el-form-item>
        </el-form>
    </drag-dialog>
  </div>
</template>

<script>
    import Cookies from 'js-cookie'
    import DragDialog from "@/components/DragDialog"
    import { updatePwd } from "@/api/user";

    export default {
        name: 'Login',
        components: { DragDialog},
        data() {
            return {
                loginForm: {
                    username: '',
                    password: '',
                    rememberMe: false
                },
                loginRules: {
                    username: [{required: true, trigger: 'blur', message: '用户名不能为空'}],
                    password: [{required: true, trigger: 'blur', message: '密码不能为空'}]
                },
                loading: false,
                redirect: undefined,
                dialogShow: false,
                 form: {
                    oldPwd: "",
                    password: "",
                    rePassword: ""
                  },
                rules: {
                oldPwd: [{ required: true, message: "请输入原密码", trigger: "blur" }],
                password: [
                  { required: true, message: "请输入新密码", trigger: "blur" }
                ],
                rePassword: [{ required: true, message: "请确认密码", trigger: "blur" }]
              }
            }
        },
        watch: {
            $route: {
                handler(route) {
                    this.redirect = route.query && route.query.redirect
                },
                immediate: true
            }
        },
        created() {
            const code = this.$route.query.code
            if (code) {
                this.$store.dispatch('user/Login', {code}).then(() => {
                    this.loading = false
                    this.$router.push({path: this.redirect || '/'})
                }).catch(() => {
                    this.loading = false
                })
            } else {
                this.getCookie()
            }
        },
        methods: {
          // 修改密码
          onSubmit(formName) {
              this.$refs[formName].validate(valid => {
                if (valid) {
                  if (this.form.password === '123456' && this.form.rePassword === '123456') {
                     return this.$notify({ title: "新密码不能为123456，请重新输入！", type: "error",duration: 2500  });
                  }
                  updatePwd(this.form).then(res => {
                  // console.log(res);
                  this.$notify({
                    title: "修改成功,请重新登录！",
                    type: "success",
                    duration: 2500
                  });
                  this.form = {};
                  this.loginForm.password = ''
                  this.dialogShow = false
                });
                } else {
                  // alert("校验失败")
                  console.log("校验失败");
                  return false;
                }
              });
          },
          cancel() {
            this.form = {};
            this.dialogShow = false;
          },
            getCookie() {
                const username = Cookies.get('username')
                let password = Cookies.get('password')
                const rememberMe = Cookies.get('rememberMe')
                // 保存cookie里面的加密后的密码
                password = password === undefined ? '' : password
                this.loginForm = {
                    username: username === undefined ? '' : username,
                    password: password,
                    rememberMe: rememberMe === undefined ? false : Boolean(rememberMe)
                }
            },
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    const user = this.loginForm
                    if (valid) {
                        this.loading = true
                        if (user.rememberMe) {
                            Cookies.set('username', user.username, {expires: 1})
                            Cookies.set('password', user.password, {expires: 1})
                            Cookies.set('rememberMe', user.rememberMe, {expires: 1})
                        } else {
                            Cookies.remove('username')
                            Cookies.remove('password')
                            Cookies.remove('rememberMe')
                        }
                        this.$store.dispatch('user/Login', user).then(() => {
                            this.loading = false
                            console.log('1111',user)
                            // 首次登录如果密码为123456  提醒用户更改密码再登录
                            if (user.password === '123456') {
                              this.dialogShow = true
                              this.form.oldPwd = user.password
                            } else {
                               this.$router.push({path: '/'})
                            }
                        }).catch((res) => {
                            this.loading = false
                        })
                    }
                })
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
.error-box{
  margin-bottom: 14px;
  color: #1369A8;
  margin-left: 20px;
}
  .login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-image: url(../../assets/login_bg.png);
    background-size: cover;
  }

  .title {
    margin: 0px auto 20px auto;
    text-align: center;
    color: #1369A8;
    font-weight: 600;
  }

  .login-form {
    margin-left: 45%;
    margin-top: 50px;
    border-radius: 6px;
    background: #ffffff;
    width: 300px;
    padding: 50px 25px 40px 25px;
    box-shadow: 0px -1px 20px rgba(0, 0, 0, .12);

    .el-input {
      height: 38px;

      input {
        padding-left: 46px;
        border: none;
        border-bottom: 1px solid #eee;
        height: 38px;
        background: #fff;
      }
    }
  }

  .login-tip {
    font-size: 13px;
    text-align: center;
    color: #bfbfbf;
  }
</style>
